// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Managers
//import ColorManager from '../styles/ColorManager';

// Components
//import StatCard from '../components/StatCard';
import Grid from '@material-ui/core/Grid';
import DataTable from '../components/DataTable';
import Typography from '@material-ui/core/Typography';
//import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  cardFilter: any;
  cards: any;
}

interface Props {
  location: any;
  navigation: any;
}

/**
 * @description Borrows View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Inside extends React.Component<Props, State> {

  /**
   * Creates an instance of Borrows.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    document.title = "Rouges-Terres | Pièces";
  }

  /**
   * @description Render the BorrowsView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const columns = [
      { id: 'id', numeric: true, disablePadding: false, label: 'Id' },
      { id: 'name', numeric: false, disablePadding: false, label: 'Nom' },
      { id: 'description', numeric: false, disablePadding: false, label: 'Description' }
    ];
    const actions = [
      "close",
      "update",
      "delete"
    ];

    return (
      <div>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={12}>
            <Typography variant="headline" gutterBottom={true}>Pièces</Typography>
          </Grid>
          <Grid item={true} xs={12}>
            <Typography variant="body1" gutterBottom={true} style={{marginBottom: 16}}>Il s'agit des pièces apparaissant sur la page d'accueil du site.</Typography>
          </Grid>
        </Grid>

        <DataTable title="Les pièces" actions={actions} columns={columns} rows="inside" apiPath="inside"
          isPossibleToFilter={false} urlPath="Pieces" />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Inside.tsx